import { useEffect, useState } from "react";
import { academyRequest } from "./academyApi";
import { useIdentity } from "./useIdentity";

type Preference = { programAnnouncements: "OFF" | "IMMEDIATE" | "DAILY" | "WEEKLY" };
export function ProgramAnnouncementPreference() {
  const identity = useIdentity();
  const account = identity.session?.user.id;
  const [value, setValue] = useState<Preference["programAnnouncements"]>("OFF");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    if (!account) return;
    let active = true;
    void academyRequest<Preference>("me/notifications/preferences")
      .then(result => {
        if (active) {
          setValue(result.programAnnouncements);
          setLoading(false);
        }
      })
      .catch(() => {
        if (active) {
          setMessage("Preferences are unavailable.");
          setLoading(false);
        }
      });
    return () => {
      active = false;
    };
  }, [account]);
  async function update(next: "OFF" | "IMMEDIATE") {
    setSaving(true);
    setMessage("");
    try {
      const result = await academyRequest<Preference>(
        "me/notifications/preferences",
        { programAnnouncements: next },
        "PATCH",
      );
      setValue(result.programAnnouncements);
      setMessage("Your Program announcement choice was saved.");
    } catch {
      setMessage("Your choice could not be saved. Try again.");
    } finally {
      setSaving(false);
    }
  }
  return (
    <div className="setting-row" aria-label="New Program notifications">
      <div>
        <strong>New Program announcements</strong>
        <p>
          Optional. Publication alerts require approved Program targeting and are integration required for
          beta. Application, Offer, finance and security notices remain in your in-app history.
        </p>
        {message && <p role="status">{message}</p>}
      </div>
      <select
        aria-label="New Program announcements"
        value={value}
        disabled={!account || loading || saving}
        onChange={event => void update(event.target.value as "OFF" | "IMMEDIATE")}
      >
        <option value="OFF">Off</option>
        <option value="IMMEDIATE">Notify me when available</option>
        {value === "DAILY" && <option value="DAILY">Daily digest (not yet available)</option>}
        {value === "WEEKLY" && <option value="WEEKLY">Weekly digest (not yet available)</option>}
      </select>
    </div>
  );
}
